// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TestSheetRouteImport } from './routes/test-sheet'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SuggestRouteImport } from './routes/suggest'
import { Route as SearchRouteImport } from './routes/search'
import { Route as QrRouteImport } from './routes/qr'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OrganizersRouteImport } from './routes/organizers'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForOrganizersRouteImport } from './routes/for-organizers'
import { Route as CreateOrganizerRouteImport } from './routes/create-organizer'
import { Route as CreateEventRouteImport } from './routes/create-event'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as ProfileSettingsRouteImport } from './routes/profile/settings'
import { Route as ProfileCalendarRouteImport } from './routes/profile/calendar'
import { Route as OrganizerOrganizerIdRouteImport } from './routes/organizer/$organizerId'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as CheckoutRegistrationIdRouteImport } from './routes/checkout/$registrationId'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AdminImportRouteImport } from './routes/admin/import'
import { Route as AdminBlogCreateRouteImport } from './routes/admin/blog-create'
import { Route as AdminBlogRouteImport } from './routes/admin/blog'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardConnectionsRouteImport } from './routes/dashboard/connections'
import { Route as DashboardCalendarRouteImport } from './routes/dashboard/calendar'
import { Route as RiderProfileIdIndexRouteImport } from './routes/rider/$profileId/index'
import { Route as ProfileListsIndexRouteImport } from './routes/profile/lists/index'
import { Route as EventEventIdIndexRouteImport } from './routes/event/$eventId/index'
import { Route as RiderProfileIdListsRouteImport } from './routes/rider/$profileId/lists'
import { Route as EventEventIdEditRouteImport } from './routes/event/$eventId/edit'
import { Route as AdminOrganizerOrganizerIdRouteImport } from './routes/admin/organizer/$organizerId'
import { Route as AdminConnectOrganizerIdRouteImport } from './routes/admin/connect.$organizerId'
import { Route as AdminBlogEditIdRouteImport } from './routes/admin/blog-edit.$id'
import { Route as OrganizerOrganizerIdIndexRouteImport } from './routes/organizer/$organizerId/index'
import { Route as OrganizerOrganizerIdMembersRouteImport } from './routes/organizer/$organizerId/members'
import { Route as AdminBlogIndexRouteImport } from './routes/admin/blog/index'
import { Route as DashboardListsIndexRouteImport } from './routes/dashboard/lists/index'
import { Route as DashboardListsNewRouteImport } from './routes/dashboard/lists/new'
import { Route as ProfileListsListIdIndexRouteImport } from './routes/profile/lists/$listId/index'
import { Route as RiderProfileIdListListIdRouteImport } from './routes/rider/$profileId/list/$listId'
import { Route as ProfileListsListIdEditRouteImport } from './routes/profile/lists/$listId/edit'
import { Route as AdminDashboardOrganizerOrganizerIdRouteImport } from './routes/admin/dashboard/organizer/$organizerId'
import { Route as AdminDashboardEventEventIdRouteImport } from './routes/admin/dashboard/event/$eventId'
import { Route as DashboardListsListIdIndexRouteImport } from './routes/dashboard/lists/$listId/index'
import { Route as DashboardListsListIdEditRouteImport } from './routes/dashboard/lists/$listId/edit'
import { Route as AdminDashboardEventEventIdIndexRouteImport } from './routes/admin/dashboard/event/$eventId/index'
import { Route as AdminDashboardEventEventIdParticipantsRouteImport } from './routes/admin/dashboard/event/$eventId/participants'
import { Route as AdminDashboardEventEventIdEditRouteImport } from './routes/admin/dashboard/event/$eventId/edit'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TestSheetRoute = TestSheetRouteImport.update({
            id: '/test-sheet',path: '/test-sheet',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SuggestRoute = SuggestRouteImport.update({
            id: '/suggest',path: '/suggest',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const QrRoute = QrRouteImport.update({
            id: '/qr',path: '/qr',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const OrganizersRoute = OrganizersRouteImport.update({
            id: '/organizers',path: '/organizers',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForOrganizersRoute = ForOrganizersRouteImport.update({
            id: '/for-organizers',path: '/for-organizers',getParentRoute: () => rootRouteImport
          })
const CreateOrganizerRoute = CreateOrganizerRouteImport.update({
            id: '/create-organizer',path: '/create-organizer',getParentRoute: () => rootRouteImport
          })
const CreateEventRoute = CreateEventRouteImport.update({
            id: '/create-event',path: '/create-event',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProfileIndexRoute = ProfileIndexRouteImport.update({
            id: '/profile/',path: '/profile/',getParentRoute: () => rootRouteImport
          })
const ProfileSettingsRoute = ProfileSettingsRouteImport.update({
            id: '/profile/settings',path: '/profile/settings',getParentRoute: () => rootRouteImport
          })
const ProfileCalendarRoute = ProfileCalendarRouteImport.update({
            id: '/profile/calendar',path: '/profile/calendar',getParentRoute: () => rootRouteImport
          })
const OrganizerOrganizerIdRoute = OrganizerOrganizerIdRouteImport.update({
            id: '/organizer/$organizerId',path: '/organizer/$organizerId',getParentRoute: () => rootRouteImport
          })
const InviteTokenRoute = InviteTokenRouteImport.update({
            id: '/invite/$token',path: '/invite/$token',getParentRoute: () => rootRouteImport
          })
const CheckoutRegistrationIdRoute = CheckoutRegistrationIdRouteImport.update({
            id: '/checkout/$registrationId',path: '/checkout/$registrationId',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AdminImportRoute = AdminImportRouteImport.update({
            id: '/admin/import',path: '/admin/import',getParentRoute: () => rootRouteImport
          })
const AdminBlogCreateRoute = AdminBlogCreateRouteImport.update({
            id: '/admin/blog-create',path: '/admin/blog-create',getParentRoute: () => rootRouteImport
          })
const AdminBlogRoute = AdminBlogRouteImport.update({
            id: '/admin/blog',path: '/admin/blog',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardRouteRoute
          })
const DashboardConnectionsRoute = DashboardConnectionsRouteImport.update({
            id: '/connections',path: '/connections',getParentRoute: () => DashboardRouteRoute
          })
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => DashboardRouteRoute
          })
const RiderProfileIdIndexRoute = RiderProfileIdIndexRouteImport.update({
            id: '/rider/$profileId/',path: '/rider/$profileId/',getParentRoute: () => rootRouteImport
          })
const ProfileListsIndexRoute = ProfileListsIndexRouteImport.update({
            id: '/profile/lists/',path: '/profile/lists/',getParentRoute: () => rootRouteImport
          })
const EventEventIdIndexRoute = EventEventIdIndexRouteImport.update({
            id: '/event/$eventId/',path: '/event/$eventId/',getParentRoute: () => rootRouteImport
          })
const RiderProfileIdListsRoute = RiderProfileIdListsRouteImport.update({
            id: '/rider/$profileId/lists',path: '/rider/$profileId/lists',getParentRoute: () => rootRouteImport
          })
const EventEventIdEditRoute = EventEventIdEditRouteImport.update({
            id: '/event/$eventId/edit',path: '/event/$eventId/edit',getParentRoute: () => rootRouteImport
          })
const AdminOrganizerOrganizerIdRoute = AdminOrganizerOrganizerIdRouteImport.update({
            id: '/admin/organizer/$organizerId',path: '/admin/organizer/$organizerId',getParentRoute: () => rootRouteImport
          })
const AdminConnectOrganizerIdRoute = AdminConnectOrganizerIdRouteImport.update({
            id: '/admin/connect/$organizerId',path: '/admin/connect/$organizerId',getParentRoute: () => rootRouteImport
          })
const AdminBlogEditIdRoute = AdminBlogEditIdRouteImport.update({
            id: '/admin/blog-edit/$id',path: '/admin/blog-edit/$id',getParentRoute: () => rootRouteImport
          })
const OrganizerOrganizerIdIndexRoute = OrganizerOrganizerIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OrganizerOrganizerIdRoute
          })
const OrganizerOrganizerIdMembersRoute = OrganizerOrganizerIdMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => OrganizerOrganizerIdRoute
          })
const AdminBlogIndexRoute = AdminBlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminBlogRoute
          })
const DashboardListsIndexRoute = DashboardListsIndexRouteImport.update({
            id: '/lists/',path: '/lists/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardListsNewRoute = DashboardListsNewRouteImport.update({
            id: '/lists/new',path: '/lists/new',getParentRoute: () => DashboardRouteRoute
          })
const ProfileListsListIdIndexRoute = ProfileListsListIdIndexRouteImport.update({
            id: '/profile/lists/$listId/',path: '/profile/lists/$listId/',getParentRoute: () => rootRouteImport
          })
const RiderProfileIdListListIdRoute = RiderProfileIdListListIdRouteImport.update({
            id: '/rider/$profileId/list/$listId',path: '/rider/$profileId/list/$listId',getParentRoute: () => rootRouteImport
          })
const ProfileListsListIdEditRoute = ProfileListsListIdEditRouteImport.update({
            id: '/profile/lists/$listId/edit',path: '/profile/lists/$listId/edit',getParentRoute: () => rootRouteImport
          })
const AdminDashboardOrganizerOrganizerIdRoute = AdminDashboardOrganizerOrganizerIdRouteImport.update({
            id: '/admin/dashboard/organizer/$organizerId',path: '/admin/dashboard/organizer/$organizerId',getParentRoute: () => rootRouteImport
          })
const AdminDashboardEventEventIdRoute = AdminDashboardEventEventIdRouteImport.update({
            id: '/admin/dashboard/event/$eventId',path: '/admin/dashboard/event/$eventId',getParentRoute: () => rootRouteImport
          })
const DashboardListsListIdIndexRoute = DashboardListsListIdIndexRouteImport.update({
            id: '/lists/$listId/',path: '/lists/$listId/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardListsListIdEditRoute = DashboardListsListIdEditRouteImport.update({
            id: '/lists/$listId/edit',path: '/lists/$listId/edit',getParentRoute: () => DashboardRouteRoute
          })
const AdminDashboardEventEventIdIndexRoute = AdminDashboardEventEventIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminDashboardEventEventIdRoute
          })
const AdminDashboardEventEventIdParticipantsRoute = AdminDashboardEventEventIdParticipantsRouteImport.update({
            id: '/participants',path: '/participants',getParentRoute: () => AdminDashboardEventEventIdRoute
          })
const AdminDashboardEventEventIdEditRoute = AdminDashboardEventEventIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => AdminDashboardEventEventIdRoute
          })





const DashboardRouteRouteChildren = {
  DashboardCalendarRoute: DashboardCalendarRoute,DashboardConnectionsRoute: DashboardConnectionsRoute,DashboardSettingsRoute: DashboardSettingsRoute,DashboardListsNewRoute: DashboardListsNewRoute,DashboardListsIndexRoute: DashboardListsIndexRoute,DashboardListsListIdEditRoute: DashboardListsListIdEditRoute,DashboardListsListIdIndexRoute: DashboardListsListIdIndexRoute
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(DashboardRouteRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const AdminBlogRouteChildren = {
  AdminBlogIndexRoute: AdminBlogIndexRoute
}

const AdminBlogRouteWithChildren = AdminBlogRoute._addFileChildren(AdminBlogRouteChildren)




const OrganizerOrganizerIdRouteChildren = {
  OrganizerOrganizerIdMembersRoute: OrganizerOrganizerIdMembersRoute,OrganizerOrganizerIdIndexRoute: OrganizerOrganizerIdIndexRoute
}

const OrganizerOrganizerIdRouteWithChildren = OrganizerOrganizerIdRoute._addFileChildren(OrganizerOrganizerIdRouteChildren)




const AdminDashboardEventEventIdRouteChildren = {
  AdminDashboardEventEventIdEditRoute: AdminDashboardEventEventIdEditRoute,AdminDashboardEventEventIdParticipantsRoute: AdminDashboardEventEventIdParticipantsRoute,AdminDashboardEventEventIdIndexRoute: AdminDashboardEventEventIdIndexRoute
}

const AdminDashboardEventEventIdRouteWithChildren = AdminDashboardEventEventIdRoute._addFileChildren(AdminDashboardEventEventIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DashboardRouteRoute: DashboardRouteRouteWithChildren,BlogRoute: BlogRouteWithChildren,CreateEventRoute: CreateEventRoute,CreateOrganizerRoute: CreateOrganizerRoute,ForOrganizersRoute: ForOrganizersRoute,LoginRoute: LoginRoute,OrganizersRoute: OrganizersRoute,PrivacyRoute: PrivacyRoute,QrRoute: QrRoute,SearchRoute: SearchRoute,SuggestRoute: SuggestRoute,TermsRoute: TermsRoute,TestSheetRoute: TestSheetRoute,UnsubscribeRoute: UnsubscribeRoute,AdminBlogRoute: AdminBlogRouteWithChildren,AdminBlogCreateRoute: AdminBlogCreateRoute,AdminImportRoute: AdminImportRoute,AuthCallbackRoute: AuthCallbackRoute,CheckoutRegistrationIdRoute: CheckoutRegistrationIdRoute,InviteTokenRoute: InviteTokenRoute,OrganizerOrganizerIdRoute: OrganizerOrganizerIdRouteWithChildren,ProfileCalendarRoute: ProfileCalendarRoute,ProfileSettingsRoute: ProfileSettingsRoute,ProfileIndexRoute: ProfileIndexRoute,AdminBlogEditIdRoute: AdminBlogEditIdRoute,AdminConnectOrganizerIdRoute: AdminConnectOrganizerIdRoute,AdminOrganizerOrganizerIdRoute: AdminOrganizerOrganizerIdRoute,EventEventIdEditRoute: EventEventIdEditRoute,RiderProfileIdListsRoute: RiderProfileIdListsRoute,EventEventIdIndexRoute: EventEventIdIndexRoute,ProfileListsIndexRoute: ProfileListsIndexRoute,RiderProfileIdIndexRoute: RiderProfileIdIndexRoute,AdminDashboardEventEventIdRoute: AdminDashboardEventEventIdRouteWithChildren,AdminDashboardOrganizerOrganizerIdRoute: AdminDashboardOrganizerOrganizerIdRoute,ProfileListsListIdEditRoute: ProfileListsListIdEditRoute,RiderProfileIdListListIdRoute: RiderProfileIdListListIdRoute,ProfileListsListIdIndexRoute: ProfileListsListIdIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)